import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Spacing } from '../../styles';
import { Button } from '../crop-circle/Button';
import { SystemNotification } from '../system-notification';
import { BottomBar } from './bottomBar';
import { RestartButton } from './restartButton';
import { BottomComponentBarBaseProps } from './types';

export const BottomComponentBar = (props: BottomComponentBarBaseProps) => {
  const isWeb = Platform.OS === 'web';
  const left = props.left || props.backButton;
  const right = props.right ? (
    props.right
  ) : props.onRightPress ? (
    <RestartButton
      onPress={props.onRightPress}
      disabled={props.rightPressDisabled}
    />
  ) : undefined;

  const innerBlock =
    props.additionalHeaderBlock ||
    (props.onSave ? (
      <SaveButton
        onPress={() => props.onSave?.()}
        disabled={props.rightPressDisabled}
        label={props.saveLabel}
        fontSize={!isWeb ? 14 : undefined}
      />
    ) : undefined);

  // Mirror the Back button's left margin on the right side of the center block
  // when there's no right button. Keeps the bottom bar visually symmetric.
  // When a right button is present, it already brings its own spacing.
  const centerBlock =
    innerBlock && !right ? (
      <View style={styles.centerBlockRightMargin}>{innerBlock}</View>
    ) : (
      innerBlock
    );

  return (
    <>
      <BottomBar
        style={props.style}
        left={left}
        right={right}
        additionalHeaderBlock={centerBlock}
      />
      <SystemNotification />
    </>
  );
};

type SaveButtonProps = {
  onPress: () => void;
  disabled?: boolean;
  style?: StyleProp<ViewStyle>;
  label?: string;
  isLoading?: boolean;
  activeTextColor?: string;
  fontSize?: number;
};

const SaveButton: FC<SaveButtonProps> = (props: SaveButtonProps) => {
  const { t } = useTranslation();
  const state = props.disabled ? 'default' : 'active';

  return (
    <Button
      onPress={props.onPress}
      style={StyleSheet.flatten([styles.saveButtonContainer, props.style])}
      state={state}
      disabled={props.disabled}
    >
      {props.label || t('topNav.save')}
    </Button>
  );
};

const styles = StyleSheet.create({
  saveButtonContainer: {
    flex: 1,
    height: 56,
    maxHeight: 56,
  },
  centerBlockRightMargin: {
    flexGrow: 1,
    marginRight: Spacing.baseMargin.base,
  },
});
